"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Scissors1: ['scissors-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.066,16.393A3.866,3.866,0,0,0,14.155,17.7l-.9-2.263a.245.245,0,0,1,.093-.295A14.146,14.146,0,0,0,20,3.465,12.83,12.83,0,0,0,19.624.379a.5.5,0,0,0-.935-.1L12.225,13.529a.251.251,0,0,1-.45,0L5.31.281a.5.5,0,0,0-.935.1A12.891,12.891,0,0,0,4,3.465a14.146,14.146,0,0,0,6.654,11.682.246.246,0,0,1,.094.295l-.9,2.264A3.858,3.858,0,1,0,6.857,24a3.913,3.913,0,0,0,3.52-2.225L12,17.7l1.652,4.141A3.874,3.874,0,0,0,20.9,19.229,3.837,3.837,0,0,0,18.066,16.393ZM8.714,20.55l-.165.415A1.882,1.882,0,0,1,6.857,22a1.857,1.857,0,1,1,1.857-1.857ZM17.143,22a1.871,1.871,0,0,1-1.662-.965l-.2-.491v-.4A1.857,1.857,0,1,1,17.143,22Z']],
  Scissors: ['scissors', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.745,14.125a3.94,3.94,0,0,0-3.423.717A11.907,11.907,0,0,0,16.2,12.116a.231.231,0,0,1,0-.233,11.925,11.925,0,0,0,1.118-2.726,3.943,3.943,0,0,0,3.423.717,4,4,0,0,0-1.236-7.868A4.068,4.068,0,0,0,15.75,6.032a9.917,9.917,0,0,1-1,4.274.251.251,0,0,1-.414.05A11.452,11.452,0,0,0,5.75,6.5c-1.057,0-4.287.338-5.3,1.1a.5.5,0,0,0,.165.881l11.629,3.28a.25.25,0,0,1,0,.481L.614,15.52a.5.5,0,0,0-.165.881c1.014.76,4.244,1.1,5.3,1.1a11.451,11.451,0,0,0,8.587-3.856.25.25,0,0,1,.414.05,9.91,9.91,0,0,1,1,4.274,4.067,4.067,0,0,0,3.759,4.025,4,4,0,0,0,1.236-7.867ZM19.75,20a2,2,0,1,1,2-2A2,2,0,0,1,19.75,20Zm0-16a2,2,0,1,1-2,2A2,2,0,0,1,19.75,4Z']],
  CopyPaste: ['copy-paste', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.4,4.727a.251.251,0,0,0,.2.265A1.089,1.089,0,0,1,14.424,6.1V7.5a1.244,1.244,0,0,0,1.244,1.244h0A1.244,1.244,0,0,0,16.913,7.5V3.975a1.494,1.494,0,0,0-1.5-1.494H13.689a.246.246,0,0,0-.177.074.249.249,0,0,0-.073.177C13.441,3.205,13.44,4.224,13.4,4.727Z', 'M8.954,21.262A1.244,1.244,0,0,0,7.71,20.018H3.484a1.073,1.073,0,0,1-1-1.136V6.1a1.086,1.086,0,0,1,.842-1.115.25.25,0,0,0,.2-.258c-.039-.766-.051-1.6-.055-2a.25.25,0,0,0-.25-.247H1.5A1.494,1.494,0,0,0,0,3.975V21.012a1.493,1.493,0,0,0,1.494,1.493H7.71a1.244,1.244,0,0,0,1.244-1.243Z', 'M11.937,4.472V2.484a.5.5,0,0,0-.5-.5h-.758a.251.251,0,0,1-.249-.222,1.989,1.989,0,0,0-3.953,0,.249.249,0,0,1-.249.222H5.473a.5.5,0,0,0-.5.5V4.472a.5.5,0,0,0,.5.5H11.44A.5.5,0,0,0,11.937,4.472Z', 'M19.02,17.269H15.041a.75.75,0,1,0,0,1.5H19.02a.75.75,0,1,0,0-1.5Z', 'M14.291,14.54a.75.75,0,0,0,.75.749h2.486a.75.75,0,1,0,0-1.5H15.041A.75.75,0,0,0,14.291,14.54Z', 'M23.5,13.46a1.991,1.991,0,0,0-.584-1.409l-1.406-1.4a1.994,1.994,0,0,0-1.41-.584H12.494A1.993,1.993,0,0,0,10.5,12.055V22a2,2,0,0,0,2,2h9a2,2,0,0,0,2-2Zm-11-.4a1,1,0,0,1,1-1l6.187,0a1,1,0,0,1,.707.292l.818.816a1,1,0,0,1,.293.708V21a1,1,0,0,1-1,1h-7a1,1,0,0,1-1-1Z']],
  Scissors2: ['scissors-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.756,17.746l-9.275-5.513a.25.25,0,0,1,0-.432l9.265-5.313a.5.5,0,0,0,.182-.689,2.7,2.7,0,0,0-3.551-.923L9.781,10.8a.25.25,0,0,1-.24,0L7.117,9.49A4.456,4.456,0,1,0,.552,8.053a.965.965,0,0,0,.389.376l6.207,3.35a.25.25,0,0,1,0,.44L.941,15.57a.946.946,0,0,0-.389.376,4.469,4.469,0,0,0,.733,5.283,4.169,4.169,0,0,0,1.856,1.13,4.462,4.462,0,0,0,3.976-7.85L9.538,13.2a.254.254,0,0,1,.245,0l10.59,6.143a2.461,2.461,0,0,0,1.253.329,2.692,2.692,0,0,0,2.3-1.245A.5.5,0,0,0,23.756,17.746ZM4.955,8.324l-2.776-1.5a2.462,2.462,0,1,1,4.749-.915A2.482,2.482,0,0,1,4.955,8.324ZM4.466,20.551a2.467,2.467,0,0,1-2.287-3.377l2.776-1.5a2.463,2.463,0,0,1-.489,4.876Z']]
};
exports["default"] = _default;